import { TFormValidationResult } from '../models'
import { FormValidationBuilder } from '../utils/validation'

export const validateFormData = async <T extends object>(
  formData: T,
  formKey: string,
  fields?: string[]
) => {
  const messages: TFormValidationResult[] = []

  const formValidation = FormValidationBuilder.build(formKey)

  for (const [field, value] of Object.entries(formData)) {
    if (fields && fields.length > 0 && !fields.includes(field)) {
      continue
    }

    const validationResult = await formValidation.call(field, value)

    if (validationResult) {
      messages.push(validationResult)
    }
  }

  return messages
}
